<template>
  <!-- Modal para crear/editar -->
  <b-modal id="bv-modal-manage-custom-fields" hide-footer>
    <template #modal-title>
      {{ action === 'EDIT' ? 'Editar' : 'Crear' }} campos personalizados
    </template>

    <b-form @submit.prevent="onHandleSaveCustomField()" data-vv-scope="customFieldForm">

      <b-form-group id="title-group" label="Campo personalizado:" label-for="title">
        <b-form-input id="label" name="title" v-validate="'required|max:1|max:255'" data-vv-as=" "
          v-model="customField.title" type="text" placeholder="Título para el campo personalizado"></b-form-input>
        <span class="text-danger small" v-text="errors.first('customFieldForm.title')" />
      </b-form-group>

      <b-form-group id="slq_custom_field_nu_gre_id-group" label="Seleccionar padre:"
        label-for="slq_custom_field_nu_gre_id">
        <Treeselect id="slq_custom_field_nu_gre_id" :value="value" v-model="customField.slq_custom_field_nu_gre_id"
          name="slq_custom_field_nu_gre_id" clearable :options="getCustomFields()" :normalizer="normalizerSelectTree"
          placeholder="Seleccionar" :flatten-search-results="true" :defaultExpandLevel="Infinity"
          no-results-text="No se encontraron resultados." :max-height="300" class="custom-treeselect"
          value-consists-of="ALL" noOptionsText="No hay resultados para mostrar">
        </Treeselect>

        <span class="text-danger small" v-text="errors.first('customFieldForm.slq_custom_field_nu_gre_id')" />
      </b-form-group>

      <div class="d-flex justify-content-end align-items-center d-flex-grap mb-2">
        <b-button type="submit" variant="primary">{{ action === 'CREATE' ? 'Agregar campo' : 'Guardar cambios' }}</b-button>
        <b-button class="ml-2" type="reset" variant="light" @click="onHandleCancel()">Cancelar</b-button>
      </div>

    </b-form>

  </b-modal>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from "vuex";

// Componentes
import Treeselect from "@riophae/vue-treeselect";

// Estilos adicionales
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css";

export default {
  name: "CustomFieldsFormComponent",
  data() {
    return {
      value: null
    };
  },
  components: {
    Treeselect
  },
  computed: {
    // Estados para el modulo del Naciones unidas - gre
    ...mapState('NuGreCustomFields', [
      'customField',
      'customFields',
      'action'
    ]),
  },
  methods: {
    // Acciones para el modulo del Naciones unidas - gre
    ...mapActions('NuGreCustomFields', [
      'store',
      'update'
    ]),
    // Mutaciones para el modulo del Naciones unidas - gre
    ...mapMutations('NuGreCustomFields', [
      'resetCustomField',
      'setAction'
    ]),
    /**
     *  Propiedades y métodos para el selector.
     * @author Fernando Claros
     */
    getCustomFields() {
      return this.customFields.itemInTree
    },
    /**
     *  Propiedades y métodos para el selector.
     * @author Fernando Claros
     */
    normalizerSelectTree(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    /**
     * Crear campos personalizados.
     * @author Fernando Claros
     */
    async onHandleSaveCustomField() {
      this.$validator.validateAll('customFieldForm')
        .then(async (result) => {
          if (result) {

            const payload = {
              id: this.customField.id,
              title: this.customField.title,
              slq_custom_field_nu_gre_id: this.customField.slq_custom_field_nu_gre_id || null
            };

            if (this.action === 'CREATE') await this.store(payload).then(() => this.onHandleCancel())
            else await this.update(payload).then(() => this.onHandleCancel())
          }
        });
    },
    /**
     * Cancelar acciones.
     * @author Fernando Claros
     */
    onHandleCancel() {
      this.resetCustomField();
      this.setAction('CREATE');
      this.$bvModal.hide('bv-modal-manage-custom-fields')
    },
  }
};
</script>

<style scoped>
.vue-treeselect__menu-container {
  font-weight: 200 !important;
}
</style>
